
import {of as observableOf,  Observable } from 'rxjs';
import { Injector, Injectable } from '@angular/core';

import { AssociationController } from 'src/features/common/association/association.controller';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { AssociationApi } from 'src/features/common/association/association-api';

@Injectable()
export class SegmentCapacityApi implements AssociationApi {
  private readonly endpoint: string = 'portfolio/segment/';
  private readonly suffix: string = '/capacity';

  static createAssociationApi(
    apiHelper: ApiHelper,
  ): AssociationApi {
    return new SegmentCapacityApi(apiHelper);
  }

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (code: number | string): Observable<any> => {
    return observableOf([]);
  }

  public save = (itemData: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + itemData[0].code + this.suffix + '/save', { body: itemData });
  }

}

@Injectable()
export class PortfolioSegmentCapacityApi implements AssociationApi {
  private readonly endpoint: string = 'portfolio/segment/';
  private readonly suffix: string = '/capacity';

  static createAssociationApi(
    apiHelper: ApiHelper,
  ): AssociationApi {
    return new PortfolioSegmentCapacityApi(apiHelper);
  }

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (code: number | string): Observable<any> => {
    return this.apiHelper.request(this.endpoint + code + this.suffix + '/portfolio');
  }

  public save = (itemData: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + itemData[0].code + this.suffix + '/save', { body: itemData });
  }
}

